export function Reducer(previousState, action) {
  let newState = Object.assign({}, previousState);

  switch (action.type) {
    case "UPDATE_SWIM_SWITCH_LIST_SUCCESS":
      newState = Object.assign({}, previousState, {
        data: action.payload.records,
        pages: action.payload.totalPages,
        totalElements: action.payload.totalElements,
        loading: false,
        isError: false,
        shouldFetchOnEmptyFilters: true, // FIX: Allow fetching for future searches
      });
      newState.listState.page = action.payload.page;
      break;
    case "UPDATE_SWIM_SWITCH_LIST_REQUEST":
      newState = Object.assign({}, previousState, {
        listState: action.payload.listState,
        totalElements: "Loading ...",
        loading: true,
        isError: false,
        shouldFetchOnEmptyFilters: true, // FIX: Allow fetching while request is pending
      });
      break;
    case "UPDATE_SWIM_SWITCH_INDEX_ON_LIST":
      newState = Object.assign({}, previousState, {
        indexOnList: action.indexOnList,
      });
      break;
    case "UPDATE_SWIM_SWITCH_LIST_FAILURE":
      newState = Object.assign({}, previousState, {
        data: [],
        pages: 0,
        totalElements: 0,
        loading: false,
        isError: true,
        shouldFetchOnEmptyFilters: true, // FIX: Allow fetching for future searches after failure
      });

      break;
    case "RESET_ERROR_MESSAGE_SWIM_SWITCH_LIST":
      newState = Object.assign({}, previousState, {
        isError: false,
      });
      break;
    case "RESET_SWIM_SWITCH_LIST_STATE_LOCALLY":
      newState = Object.assign({}, previousState, {
        listState: action.payload.listState,
        data: [],
        pages: 0,
        totalElements: 0,
        loading: false,
        isError: false,
        shouldFetchOnEmptyFilters: false, // FIX: Explicitly prevent fetch on empty filters after reset
      });
      break;
    case "UPDATE_SWIM_SWITCH_LIST_STATE_LOCALLY": // New Action for local state update
      newState = Object.assign({}, previousState, {
        listState: action.payload.listState,
        isError: false,
        // shouldFetchOnEmptyFilters will be handled by explicit dispatch from SwimSwitchList
      });
      break;
    case "UPDATE_BIO_SIMILAR_TOGGLE":
      newState = Object.assign({}, previousState, {
        isShowBioSimilar: action.payload,
      });
      break;
    // FIX: New action type for controlling fetch on empty filters
    case "SET_SHOULD_FETCH_ON_EMPTY_FILTERS":
      newState = Object.assign({}, previousState, {
        shouldFetchOnEmptyFilters: action.payload,
      });
      break;
    default:
      break;
  }

  return newState;
}

// Initial state for the reducer (if not defined elsewhere)
// Make sure this is part of your Redux root reducer's initial state
export const initialState = {
  listState: {
    page: 0,
    pageSize: 15, // DEFAULT_PAGE_SIZE
    sorted: [], // DEFAULT_SWIM_SWITCH_SORT
    filtered: [],
    resized: [],
    expanded: {},
  },
  data: [],
  pages: 0,
  totalElements: 0,
  loading: false,
  isError: false,
  isShowBioSimilar: undefined,
  shouldFetchOnEmptyFilters: false, // FIX: Initialize to false for blank start
};
